module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-padding"
  }, [_c('div', {
    staticClass: "box-wrapper"
  }, [_c('div', {
    staticClass: "box-center big-text"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', [_vm._v("Über Bahnwelt TV")]), _vm._v(" "), _c('p', [_vm._v("Bahnwelt TV ist ein Video-on-Demand Angebot der"), _c('br'), _vm._v("\n                        König Film München."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                        Keinen Film verpassen mit unserem kostenlosen Newsletter."), _c('br'), _vm._v("\n                        Zu abonnieren auf "), _c('a', {
    attrs: {
      "href": "http://www.bahnwelt.tv"
    }
  }, [_vm._v("www.bahnwelt.tv")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Impressum:")]), _c('br'), _vm._v("\n                        König Filmproduktion"), _c('br'), _vm._v("\n                        Glogauer Str. 22"), _c('br'), _vm._v("\n                        80997 München"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.koenigfilm.de"
    }
  }, [_vm._v("www.koenigfilm.de")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Technische Realisierung der App:")]), _c('br'), _vm._v("\n                        Frank Merl Web & App Entwicklung"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.frankmerl.de"
    }
  }, [_vm._v("www.frankmerl.de")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b7001bd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Info.vue
// module id = 80
// module chunks = 0